module.exports = __webpack_public_path__ + "static/media/5.fb25f1a8.jpeg";